import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { createStyles, keyframes } from 'antd-style';
export var useStyles = createStyles(function () {
  var indicatorAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  "])));
  return {
    indicator: {
      marginInlineEnd: 8,
      animation: "".concat(indicatorAnimation, " 1.5s infinite linear")
    }
  };
});